// src/pages/Dashboard/components/CasePanel/DocumentsSection/DocumentsSection.js

import React, { useMemo } from 'react';
import DocumentItem from './DocumentItem';
import { processarDocumentos } from '../../../utils/analysisProcessor';
import { TIPOS_DOCUMENTO } from '../../../utils/dashboardConstants'; // ✅ ADICIONADO
import './DocumentsSection.css';

/**
 * Seção de documentos sugeridos
 * @param {object} caso - Caso selecionado
 * @param {function} onGenerateDocument - Callback para gerar documento
 */
const DocumentsSection = ({ caso, onGenerateDocument }) => {
  const documentos = useMemo(
    () => processarDocumentos(caso),
    [caso]
  );

  // ✅ REMOVIDO: documentosPadrao hardcoded
  // ✅ MODIFICADO: Agora usa TIPOS_DOCUMENTO do dashboardConstants.js
  return (
    <div className="secao-documentos-dashboard">
      <h3>Documentos Sugeridos</h3>
      <div className="documentos-lista-dashboard">
        {/* Documentos processados da análise do caso */}
        {documentos.length > 0 && documentos.map(doc => (
          <DocumentItem
            key={doc.id}
            documento={doc}
            onGenerate={onGenerateDocument}
          />
        ))}
        
        {/* ✅ MODIFICADO: Documentos padrão agora vêm da constante */}
        {TIPOS_DOCUMENTO.map((doc) => (
          <DocumentItem
            key={doc.id}
            documento={doc}
            onGenerate={onGenerateDocument}
          />
        ))}

        {/* Mensagem se não houver documentos */}
        {documentos.length === 0 && TIPOS_DOCUMENTO.length === 0 && (
          <div className="no-documentos">Nenhum documento disponível</div>
        )}
      </div>
    </div>
  );
};

export default DocumentsSection;